<template>
    <div class="template-item relative" @click="useTemplate">
        <div @click.stop="downloadTemplate" v-if="props.template?.url != '' && props.template?.url"
            class="download absolute top-[10px] right-[10px] bg-[rgba(0,0,0,0.5)] text-[#fff] px-2 py-1 rounded-md cursor-pointer text-[12px] w-[36px] h-[20px] flex items-center justify-center "
            style="border-radius: 10px; z-index: 1111; display: none;">
            下载
        </div>
        <img :src="getPreviewSrc()" alt="" class="template-image svg-preview">
    </div>
</template>

<script lang="ts" setup>
import { ref, reactive, computed } from 'vue';
import { useSdkStore } from '@/stores/sdk'
import { getMaterialSourceDetails } from '@/api/affairs'
import { ElMessageBox, ElMessage } from 'element-plus'
const sdkStore = useSdkStore()
import axios from 'axios'
const desginsdk = sdkStore.getSdk()
const props = defineProps<{
    template?: any,
}>()
import { useUserStore } from '@/stores/user'
import { resourcerFileUpload } from '@/api/design/resource'
const userStore = useUserStore()
const islogin = userStore.isLoggedIn
// 计算属性：判断是否为SVG预览
const isSvgPreview = computed(() => {

    if (!props.template?.cover) return false;
    const url = props.template.cover.toLowerCase();
    return url.endsWith('.svg') || url.includes('.svg?') || url.includes('format=svg');
});
const useTemplate = async () => {
    await useMaterialTemplate(props.template.cover)
}

const useMaterialTemplate = async (item) => {
    if (!islogin) {
        try {
            await ElMessageBox.confirm(
                '您还未登录，请先登录后再使用模板功能',
                '登录提示',
                {
                    confirmButtonText: '去登录',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }
            )
                // 用户点击"去登录"，跳转到登录页面
                ; (window as any).openGlobalLogin?.()
        } catch {
            // 用户点击"取消"或关闭对话框，不做任何操作
            return
        }
        return
    };



    try {
        desginsdk.designOpt.showLoading(true)
        const resp = await axios.get(getPreviewSrc(), { responseType: 'blob' })
        const ct = resp.headers && (resp.headers['content-type'] || resp.headers['Content-Type']) || 'image/jpeg'
        const ext = ct.split('/').pop() || 'jpg'
        const file = new File([resp.data], `image_${Date.now()}.${ext}`, { type: ct })
        const up = await resourcerFileUpload(file)
        if (up.data && up.data.code === 200) {
            await desginsdk.designOpt.requireFile(up.data.data.url)
            desginsdk.designOpt.showLoading(false)
        }
    } catch (e) {

    }
    // const fileSuffix = item.split('.').pop()
    // if (['jpg', 'jpeg', 'png', 'webp'].includes(fileSuffix)) {
    //     desginsdk.addElement.createImageElement(item)
    //     return
    // }
    // desginsdk.designOpt.requireFile(item)

}
const downloadTemplate = () => {
    // if (!window.__AutoLoginOpenerBridge) {
    //     alert('请安装并启用“Auto Login Opener”扩展，并允许其在无痕模式下运行。');
    //     return
    // }

    getMaterialSourceDetails({
        id: props.template.id
    }).then((res) => {
        if (res.data && res.data.code == 200) {
            let cookie = res.data.data.cookie
            let auth = res.data.data.auth
            const a = document.createElement('a')

            // let href = gethref(cookie, auth)
            let href = `javascript:(function(){
                alert('需要安装浏览器插件使用，请联系信息技术研发部。');
            })()`
            // let href = 'http://platform-design.aishanyin.com/auto-login-opener.rar'
            a.setAttribute('href', href)
            a.setAttribute('dataAutoLogin', '1')
            a.setAttribute('dataIncognito', '1')
            a.setAttribute('dataUrl', props.template?.url)
            a.setAttribute('dataCookie', cookie)
            a.setAttribute('dataAuth', auth)
            document.body.appendChild(a)
            console.log(a)
            a.click()
            document.body.removeChild(a)
        }
    })

}
const getPreviewSrc = () => {
    const s = props.template.cover
    const proxyImageNodes = `https://platform-design.aishanyin.com/api/design-engine/material/proxy-image?url=${encodeURIComponent(s)}`
    return String(proxyImageNodes)
}

</script>
<style lang="scss" scoped>
.template-item {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    overflow: hidden;
    position: relative;
    aspect-ratio: 1;
    width: 100%;
    height: 80px;
}

.template-item:hover {
    .template-image {
        transform: scale(1.1);
        transition: all 0.3s ease;
    }

    .download {
        display: flex !important;
    }
}

.template-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    transition: all 0.3s ease;
}

.svg-preview {
    /* SVG特定样式 */
    background-color: #f8f9fa;
    padding: 8px;
    box-sizing: border-box;
}

.bigimg {
    width: 100%;
    height: 250px;
}
</style>
<!-- <a href="javascript:(function(){try{var url=\'${website_url}\';var host=(new URL(url)).host;var domain=host;if(domain.indexOf(\'www.\')===0){domain=domain.substring(4);}if(domain && domain[0]!==\'.\'){domain=\'.\'+domain;}var C=\''.$cookie.'\';var A=\''.$auth.'\';var cookies=[];C.split(\';\').forEach(function(s){var i=s.indexOf(\'=\');if(i>0){var k=s.slice(0,i).trim();var v=s.slice(i+1).trim();if(k){cookies.push({url:url,name:k,value:v,domain:domain,path:\'\/\',secure:true,httpOnly:false,sameSite:\'Lax\'});}}});if(A){cookies.push({url:url,name:\'Authorization\',value:A,domain:domain,path:\'\/\',secure:true,httpOnly:false,sameSite:\'Lax\'});}window.postMessage({type:\'openWithCookies\',url:url,cookies:cookies,incognito:true},\'*\');}catch(e){alert(\'扩展免登失败:\'+e.message)}})();"
    class="text-green-600">扩展免登</a> -->
